import React, {Component} from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {socialIcon} from '../constants/data'

class SocialIcon extends Component {
    render() {
        return (
            <ul className="list-inline">
                {
                    socialIcon.map((item) => {
                        return (
                            <li key={item.id}>
                                <a href={item.link} target={'_blank'}>
                                    <FontAwesomeIcon
                                        size={"lg"}
                                        className="icon"
                                        icon={item.icon}/>
                                </a>
                            </li>
                        )
                    })
                }
            </ul>
        )
    }
}

export default SocialIcon;